module.exports = __webpack_public_path__ + "img/MAC160_1-1.8a8371f9.jpg";